import { Map } from 'immutable';
import * as request from '../../actions/relocation/relocationRequest';

const initialState = Map({
    completedStepName: 0,
    maxStep: 0,
});

// const getMaxSteps = (step) => {
//     switch(step) {
//         case 'Introduction':
//         case 'PersonalDetails': return 2;
//         case 'RelocationDetails': return 3;
//         case 'HousingConsideration': return 4;
//         case 'PetDetails': return 5;
//         case 'TravelDetails': return 6;
//         case 'TemporaryAccommodation': return 7;
//         case 'OtherConsiderations': return 8;
//         case 'InventoryDetails': return 9;
//         case 'DirectCreditAuthorisation': return 10;
//         case 'Declaration': return 11;
//         case 'SubmitAFR': return 12;
//         default: return 0;
//     }
// }

const actionsMap = {
    [request.SAVE_COMPLETED_STEP_NAME]: (state, action) => {
        return state.set('completedStepName', action.data);
    },
    [request.SAVE_MAX_NAME]: (state, action) => {
        return state.set('maxStep', action.data);
    },
    [request.INCREMENT_MAX_STEP]: (state, action) => {
        return state.set('maxStep', Math.max(action.data, state.get('maxStep')));
    },
    [request.INCREMENT_COMPLETED_STEP]: (state, action) => {
        return state.set('completedStepName', Math.max(action.data, state.get('completedStepName')));
    },
}

export default function facilities(state = initialState, action = {}) {
    const fn = actionsMap[action.type];
    return fn ? fn(state, action) : state;
}